import { UpFetch } from '@repo/upfetch'

import { createAnalyticsRoute } from './analytics/route'
import { createAuthRoute } from './auth/route'
import { createBillsRoute } from './bills/route'
import { createCommissionsRoute } from './comissions/route.ts'
import { createCompaniesRoute } from './companies/route'
import { createCreditSafeRoute } from './credit-safe/route.ts'
import { createHauliersRoute } from './hauliers/route'
import { createLoadsRoute } from './loads/route'
import { createOrganisationsRoute } from './organisations/route.ts'
import { createPaymentTermsRoute } from './payment-terms/route.ts'
import { createPermissionsRoute } from './permissions/route.ts'
import { createReportsRoute } from './reports/route.ts'
import { createRiskProfilesRoute } from './risk-profiles/route.ts'
import { createRolesRoute } from './roles/route.ts'
import { createShippersRoute } from './shippers/route.ts'
import { createTableConfigurationsRoute } from './table-configurations/route.ts'
import { createUsersRoute } from './users/route'
import { createXeroRoute } from './xero/route.ts'
import { createFinancialsRoute } from './financials/route.ts'
import { createCustomsRoute } from './customs/route.ts'

export const createRouter = (upFetch: UpFetch) => ({
  analytics: createAnalyticsRoute(upFetch),
  auth: createAuthRoute(upFetch),
  bills: createBillsRoute(upFetch),
  commissions: createCommissionsRoute(upFetch),
  companies: createCompaniesRoute(upFetch),
  creditSafe: createCreditSafeRoute(upFetch),
  customs: createCustomsRoute(upFetch),
  financials: createFinancialsRoute(upFetch),
  hauliers: createHauliersRoute(upFetch),
  loads: createLoadsRoute(upFetch),
  organisations: createOrganisationsRoute(upFetch),
  paymentTerms: createPaymentTermsRoute(upFetch),
  permissions: createPermissionsRoute(upFetch),
  reports: createReportsRoute(upFetch),
  riskProfiles: createRiskProfilesRoute(upFetch),
  roles: createRolesRoute(upFetch),
  shippers: createShippersRoute(upFetch),
  tableConfigurations: createTableConfigurationsRoute(upFetch),
  users: createUsersRoute(upFetch),
  xero: createXeroRoute(upFetch),
})
